export default class Tooltip {
  constructor(div) {
    this.tooltip = div;
  }

  show(opacity = 0.9) {
    this.tooltip.style('opacity', opacity);
  }

  hide() {
    this.tooltip.style('opacity', 0);
  }

  move(x, y) {
    this.tooltip
      .style('left', `${x}px`)
      .style('top', `${y}px`);
  }

  changeContent(content) {
    this.tooltip.html(content);
  }  
}